module.exports = __webpack_public_path__ + "img/hotel_plan_101124.4dc30081.jpg";